<template>
    <b-container class="mt-2">
        <b-row>
            <b-col md="12">
                <!-- Карточка со сводной информацией -->
                <b-card class="shadow-sm" header="Order summary" header-bg-variant="light" header-class="py-2 px-3">
                    <!-- Основные реквизиты: договор и судно -->
                    <b-list-group flush class="mb-2">
                        <b-list-group-item class="py-1 px-2">
                            <div class="d-flex justify-content-between align-items-center small">
                                <span class="text-muted">Ship</span>
                                <span class="font-weight-600">{{ shipName }}</span>
                            </div>
                        </b-list-group-item>
                        <b-list-group-item v-if="agreementProvider" class="py-1 px-2">
                            <div class="d-flex justify-content-between align-items-center small">
                                <span class="text-muted">Agreement</span>
                                <span class="font-weight-600">{{ agreementName }}</span>
                            </div>
                        </b-list-group-item>
                        <b-list-group-item v-else class="py-1 px-2">
                            <div class="d-flex justify-content-between align-items-center small">
                                <span class="text-muted">Payment</span>
                                <span class="font-weight-600">Stripe</span>
                            </div>
                        </b-list-group-item>
                    </b-list-group><br>
    
                    <!-- Детализация по провайдерам -->
                    <!-- Primar: единый блок ENC -->
                    <div v-if="!agreementProvider || agreementProvider === 'Primar'">
                        <b-list-group flush>
                            <b-list-group-item class="py-1 px-2">
                                <div class="d-flex justify-content-between align-items-center small">
                                    <span class="text-muted">Items</span>
                                    <span class="font-weight-600">{{ enabledItemsCount }}</span>
                                </div>
                            </b-list-group-item>
                            <b-list-group-item class="py-1 px-2">
                                <div class="d-flex justify-content-between align-items-center small">
                                    <span class="text-muted">Period</span>
                                    <span class="font-weight-600">{{ displayPeriod }} months</span>
                                </div>
                            </b-list-group-item>
                            <b-list-group-item v-if="!isOutsiderAgreement" class="py-1 px-2">
                                <div class="d-flex justify-content-between align-items-center small">
                                    <span class="text-muted">Total price</span>
                                    <span class="font-weight-600">{{ displayTotalPrice }}</span>
                                </div>
                            </b-list-group-item>
                        </b-list-group>
                    </div>
    
                    <!-- Кнопки управления заказом -->
                    <div class="d-flex justify-content-between mt-3">
                        <b-button size="sm" variant="danger" @click="$emit('cancel-order')">
                            Back
                        </b-button>
    
                        <b-button size="sm" variant="success" :disabled="preparingCells" @click="$emit('approve-order')">
                            <b-spinner v-if="preparingCells" small class="mr-1" />
                            {{ isEditMode ? $t("route.update") : $t("route.approve") }}
                        </b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import { mapStores } from "pinia";
import { useDeviceStore } from "@/stores/device";

export default {
  name: 'OrderSummary',
  props: {
    agreementName: {
      type: String,
      required: true
    },
    shipName: {
      type: String,
      required: true
    },
    agreementProvider: {
      type: String,
      required: true
    },
    enabledItemsCount: {
      type: Number,
      required: true
    },
    displayPeriod: {
      type: [String, Number],
      required: true
    },
    displayTotalPrice: {
      type: [String, Number],
      required: true
    },
    preparingCells: {
      type: Boolean,
      default: false
    },
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapStores(useDeviceStore),
    isOutsiderAgreement() {
      return this.deviceStore.getAgreementName === "GMS Electronics Primar";
    }
  },
}
</script>

<style scoped>
.font-weight-600 {
    font-weight: 600;
}

.shadow-sm {
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

/* Дополнительные стили для карточки заказа */
.card-header {
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.list-group-flush .list-group-item {
    border-width: 0 0 1px 0;
}

.small {
    font-size: 0.875rem;
}

.text-muted {
    color: #6c757d !important;
}

/* Стили для кнопок */
.btn-sm {
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    line-height: 1.5;
    border-radius: 0.2rem;
}

/* Анимация спиннера */
.spinner-border-sm {
    width: 0.875rem;
    height: 0.875rem;
}
</style>